import { BsFillCalendar2PlusFill } from "react-icons/bs";
import React from "react";

const ScheduleIcon = () => <BsFillCalendar2PlusFill style={{ margin: "0px 5px -2px 20px" }} />;

export default ScheduleIcon;
